import script from "./UploadImageComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadImageComponent.vue?vue&type=script&setup=true&lang=js"

import "./UploadImageComponent.vue?vue&type=style&index=0&id=3b65ed38&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b65ed38"]])

export default __exports__